import { c as _c } from "react/compiler-runtime";
import { graphql, type ResultOf, type VariablesOf } from "@/graphql";
import { graphqlClient } from "@/lib/graphql-client";
import { useMutation } from "@tanstack/react-query";
const validatePromoCodeQuery = graphql(`
  query validatePromoCode(
    $tier: SubscriptionTier!
    $billingInterval: BillingInterval!
    $promoCode: String!
  ) {
    validatePromoCode(
      tier: $tier
      billingInterval: $billingInterval
      promoCode: $promoCode
    ) {
      isValid
      originalTotalCents
      discountedTotalCents
      details {
        code
        description
        percentOff
        amountOffCents
        currency
        duration
        durationInMonths
      }
      error {
        reason
        message
      }
    }
  }
`);
export type ValidatePromoCodeInput = VariablesOf<typeof validatePromoCodeQuery>;
export type PromoCodeValidationResult = ResultOf<typeof validatePromoCodeQuery>["validatePromoCode"];
export function useValidatePromoCode() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
}
async function _temp(input) {
  const res = await graphqlClient.request(validatePromoCodeQuery, input);
  return res.validatePromoCode;
}